export interface UserDetails {
  personGuid: string;
  firstName: string;
  lastName: string;
  nnaId: number;
  email: string;
  orderGuid: string;
  isB2B: boolean;
}

export const mockUser: UserDetails = {
  firstName: "Roberto",
  lastName: "Haynes",
  nnaId: 847709471,
  orderGuid: "0e03e8f0-6944-1218-f2f7-962e6a048cd0",
  personGuid: "B40CB2A4-4D1D-4713-9358-3D705A4B2267",
  email: "",
  isB2B: true
};
